import {useSessionStorage} from '@aboutyou/storage';
import {useCallback} from 'react';
import {useIsAuthenticated} from '../../../Authentication/hooks/useIsAuthenticated';

type CouponWalletOpenedAs = 'guest' | 'authenticated';

export const useShowNewCouponsNotificationBadge = (couponsCount = 0) => {
  const [openedAs, setOpenedAs] = useSessionStorage<
    CouponWalletOpenedAs | undefined
  >({
    key: 'coupon_wallet_opened_as',
    defaultValue: undefined,
  });
  const {isAuthenticated} = useIsAuthenticated();

  // a dismissal from before login does not count, so the badge shows again after logging in
  const wasCouponWalletOpened =
    openedAs === 'authenticated' || (openedAs === 'guest' && !isAuthenticated);

  const setCouponWalletWasOpened = useCallback(() => {
    setOpenedAs(isAuthenticated ? 'authenticated' : 'guest');
  }, [isAuthenticated, setOpenedAs]);

  return {
    showNewCouponsNotificationBadge: wasCouponWalletOpened
      ? false
      : couponsCount > 0,
    setCouponWalletWasOpened,
  };
};
